/**
 * Created by nijin on 18/2/17.
 */
import {Component, OnInit, Input, ViewChild, EventEmitter, Output} from '@angular/core';
import {AppModalComponent} from "./modal";

@Component({
    selector: 'nuc-confirmation',
    templateUrl: './confirm.popup.html'
})
export class ConfirmationPopup implements OnInit {
  @Input() message = 'message';
  @Output() confirmation: EventEmitter<boolean> = new  EventEmitter<boolean>();
  @ViewChild('popup') popup: AppModalComponent;
  isSubmitted: boolean;
    constructor() { }

    ngOnInit() { }

    open() {
      this.isSubmitted = false;
      this.popup.open();
    }

    accept() {
      this.isSubmitted = true;
      this.confirmation.emit(true);
    }
    cancel() {
         this.confirmation.emit(false);
    }
    close() {
      this.popup.hide();
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/modal/confirmation.popup.ts